import React, { useEffect } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { DateTimePicker } from '@mui/x-date-pickers';
import { Close } from '@mui/icons-material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import {
  CircularProgress,
  IconButton,
  Modal,
  Pagination,
  TextField,
} from '@mui/material';

import { columns } from '../columns/transportation_table_columns';
import { useDashboardStore } from '../store/store';
import service from '../service/transportationsResource';

import { ColumnFactory, Excel } from './excel';
import { format } from 'date-fns';
import { useInstance } from '../hooks/useInstance';
import useExportExcel from '../hooks/useExportExcel';
import { prepareTransportationRows, prepareUnileverRow } from './ExcelRows';
import { UnileverColumns, TransportationColumns } from './ExcelColumns';
const oneDayInMillis = 24 * 60 * 60 * 1000;
const initialValue = {
  t0: new Date(new Date().getTime() - oneDayInMillis).getTime(),
  t1: Date.now(),
};
const initialState = {
  t0: initialValue.t0,
  t1: initialValue.t1,
  query: '',
};
const Transportations = () => {
  const {
    page,
    setPage,
    pageCount,
    sortModel,
    transportations,
    transportationLoading,
    closeTransportationModal,
    fetchLocationData,
    setSortModel,
    transportationModal,
    fetchTransportationData,
    fetchSeatAndBelt,
  } = useDashboardStore((state) => state);
  const isMobile = useMediaQuery('(max-width:1024px)');
  const [formState, dispatch] = React.useReducer((state, action) => {
    switch (action.type) {
      case 'CHANGE_FIELD':
        return { ...state, query: action.value };
      case 'CHANGE_DATE':
        return {
          ...state,
          [action.field]: action.value,
        };
      default:
        return state;
    }
  }, initialState);
  const [allTransportation, setAllTransportation] = React.useState([]);
  const instance = useInstance();
  const createExcel = useExportExcel(
    TransportationColumns,
    allTransportation,
    prepareTransportationRows,
    `${format(new Date(formState.t0), 'dd-MM-yyyy')}_${format(new Date(formState.t1), 'dd-MM-yyyy')}_Görevler`,
  );
  const createExcelUnilever = useExportExcel(
    UnileverColumns,
    allTransportation,
    prepareUnileverRow,
    `${format(new Date(formState.t0), 'dd-MM-yyyy')}_${format(new Date(formState.t1), 'dd-MM-yyyy')}_Görevler`,
  );

  const handleMapIconClick = (params) => {
    if (instance.id === 'amir-al0') {
      fetchSeatAndBelt(params.id);
    } else if (instance.id === 'amir-tr0') {
      fetchLocationData(params.id);
    } else {
      console.error('instance not found');
    }
  };
  const paginationChange = (_, e_page) => setPage(e_page - 1);
  const fetchAllTransportationForExcel = async () => {
    const { field, sort } =
      sortModel.length > 0
        ? sortModel[0]
        : { field: 'createdAt', sort: 'desc' };
    try {
      const params = {
        t0: format(new Date(formState.t0), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        t1: format(new Date(formState.t1), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        query: encodeURI(formState.query),
        sort: `${field},${sort}`,
        size: 999999,
      };
      const data = await service.getAllTransportationWithSearch(params);
      setAllTransportation(data?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (allTransportation.length === 0) return;
    if (instance?.id === 'amir-al0') {
      createExcelUnilever();
    } else {
      createExcel();
    }
  }, [allTransportation]);

  const memoizedColumns = React.useMemo(() => {
    if (columns[columns.length - 1].field === 'actions') {
      columns.pop();
    }
    const column = {
      field: 'actions',
      headerName: 'Göster',
      type: 'actions',
      width: 150,
      notFilter: true,
      getActions: (params) => {
        return [
          <GridActionsCellItem
            key={params.id}
            icon={<LocationOnIcon sx={{ color: '#2e3448' }} />}
            label="Haritada Göster"
            onClick={() => handleMapIconClick(params)}
          ></GridActionsCellItem>,
        ];
      },
    };
    if (columns[columns.length - 1].field !== 'actions') {
      columns.push(column);
    }
    return columns;
  }, [instance]);
  useEffect(() => {
    fetchTransportationData({ ...formState, isMobile });
  }, []);
  useEffect(() => {
    fetchTransportationData({ ...formState, isMobile });
  }, [page, sortModel, formState]);
  return (
    <>
      <Modal
        open={transportationModal}
        onClose={closeTransportationModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          className="overflow-auto rounded-lg flex gap-1 flex-col rounded-10 outline-none absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white"
          style={{
            height: isMobile ? '620px' : '720px',
            boxShadow: 24,
            width: isMobile ? '90%' : '902px',
            padding: 5,
          }}
        >
          <div className="flex items-center justify-between">
            <div>
              <h2
                id="modal-modal-title"
                className="text-lg text-[#000000DE] font-bold"
              >
                Görevler
              </h2>
            </div>
            <div>
              <IconButton component="span" onClick={closeTransportationModal}>
                <Close sx={{ color: '#2e3448' }} />
              </IconButton>
            </div>
          </div>
          <div className={`flex items-center  justify-between gap-1`}>
            <div className="flex items-center justify-between md:flex-row flex-col md:gap-1 gap-2 w-full">
              <div className="flex md:flex-row flex-col w-full items-center md:gap-1 gap-2">
                <TextField
                  size="small"
                  value={formState.query}
                  label="Ara"
                  fullWidth
                  onChange={(e) =>
                    dispatch({
                      type: 'CHANGE_FIELD',
                      value: e.target.value,
                    })
                  }
                  placeholder="Ara"
                  variant="outlined"
                  className="mr-1"
                />
                <DateTimePicker
                  label="Başlangıç Tarihi"
                  ampm={false}
                  inputFormat="dd/MM/yyyy hh:mm"
                  value={formState.t0}
                  maxDateTime={formState.t1}
                  onChange={(e) => {
                    dispatch({
                      type: 'CHANGE_DATE',
                      field: 't0',
                      value: e,
                    });
                  }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true,
                      sx: { svg: { color: '#2e3448' }, borderColor: '#2e3448' },
                    },
                  }}
                />
                <DateTimePicker
                  label="Bitiş Tarihi"
                  ampm={false}
                  inputFormat="dd/MM/yyyy hh:mm"
                  value={formState.t1}
                  onChange={(e) =>
                    dispatch({ type: 'CHANGE_DATE', field: 't1', value: e })
                  }
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true,
                      sx: { svg: { color: '#2e3448' } },
                    },
                  }}
                  maxDateTime={Date.now()}
                  minDateTime={formState.t0}
                  disableIgnoringDatePartForTimeValidation
                />
              </div>
              <button
                className="mr-1 border-[#2e3448] border-[1px] bg-[#2e3448] hover:bg-white  font-bold text-white hover:text-[#2e3448] py-2 md:w-auto w-full px-4 rounded"
                onClick={fetchAllTransportationForExcel}
              >
                Excel
              </button>
            </div>
          </div>
          <div className=" ">
            {transportationLoading ? (
              <div className="flex items-center justify-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                <DataGrid
                  sx={{ height: '100%' }}
                  rows={transportations || []}
                  columns={memoizedColumns}
                  autoHeight
                  hideFooter
                  sortModel={sortModel}
                  onSortModelChange={setSortModel}
                  disableColumnFilter
                />
                <div className="flex items-center justify-center mt-3">
                  <Pagination
                    page={page + 1}
                    onChange={paginationChange}
                    count={pageCount}
                    color="primary"
                    size="small"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Transportations;
